module.exports = __webpack_public_path__ + "static/media/m-pesa-logo.30bee665.png";